// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__3wOSa","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__2m5ya"};